module.exports = __webpack_public_path__ + "media/images/icons/outlined/align-left-dd00486635513464a24d1c3283d2ff43.svg";